// extracted by mini-css-extract-plugin
module.exports = {"BurgerMenuIcon":"BurgerMenuIcon___2EEG7","loading":"loading___26c7f"};